import { Link } from 'react-router-dom';
import { usePortalShareableLabReports } from '@/hooks/usePortalShareableLabReports';
import type { PortalShareableLabReport } from '@/hooks/usePortalShareableLabReports';
import { PortalPageHead } from '@/components/portal/PortalChrome';
import { PortalIcon } from '@/components/portal/PortalIcon';
import { statusLabel } from '@/lib/lab/labDisplay';
import { formatPortalShortDate } from '@/lib/portalFormat';

export function PortalLabResults() {
  const { data: reports = [], isLoading, error } = usePortalShareableLabReports();

  return (
    <>
      <PortalPageHead title="Labsvar" subtitle="Laboratoriesvar, som klinikken har delt med dig." />
      {isLoading ? (
        <section className="card">
          <p className="help">Henter laboratoriesvar…</p>
        </section>
      ) : error ? (
        <section className="card">
          <p className="help">Laboratoriesvarene kunne ikke hentes. Prøv igen.</p>
        </section>
      ) : reports.length === 0 ? (
        <section className="card">
          <p className="help">Klinikken har ikke delt laboratoriesvar endnu.</p>
        </section>
      ) : (
        <section className="card">
          {reports.map((report) => (
            <LabReportRow key={report.id} report={report} />
          ))}
        </section>
      )}
      <p className="help" style={{ marginTop: 16 }}>
        Har du spørgsmål til et svar, så{' '}
        <Link to="/portal/messages" className="link">
          skriv til klinikken
        </Link>
        .
      </p>
    </>
  );
}

function LabReportRow({ report }: { report: PortalShareableLabReport }) {
  const when = report.results_datetime ?? report.received_at;
  const status = statusLabel(report.report_status_code) || statusLabel(report.result_status_code);
  return (
    <div className="doc">
      <span className="ft doc">LAB</span>
      <div className="grow">
        <div className="t">
          {report.kind}
          {report.is_copy ? ' · Kopisvar' : ''}
        </div>
        <div className="s">
          {[report.sender_name, when ? formatPortalShortDate(when) : null, status !== '—' ? status : null]
            .filter(Boolean)
            .join(' · ')}
        </div>
      </div>
      <div className="r">
        <PortalIcon name="clipboard" size="sm" />
      </div>
    </div>
  );
}
